<template>
    <transition name="slide">
        <div
            v-if="show"
            class="notification-root p-3 shadow"
            :class="{ 'error-root': state === errorState() }"
            @click="deleteImmediately"
        >
            <div class="d-flex align-items-center mb-2">
                <BaseIcon
                    class="icon-color"
                    v-if="icon || errorIcon"
                    :name="icon || errorIcon"
                    size="lg"
                    :class="{ 'error-color': error === true }"
                />
                <h4 class="subtitle bold mb-0">
                    <strong>{{ title }}</strong>
                </h4>
            </div>
            <div>
                <h6 class="subtitle">{{ message }}</h6>
            </div>
        </div>
    </transition>
</template>

<script>
import { MessageState } from '~/store/customModules/messageModule';

export default {
    name: 'Notification',
    props: {
        id: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        message: String,
        state: String, // MessageState,
        duration: Number,
        icon: String,
    },
    data: () => ({
        show: false,
        timeout: null,
        errorIcon: null,
        error: false,
    }),
    methods: {
        deleteMessage() {
            this.show = false;
            setTimeout(() => {
                this.$interfaces.messageModule.deleteMessage(this.id);
            }, 1000);
        },
        deleteMessageAfterDuration() {
            this.timeout = setTimeout(
                this.deleteMessage,
                this.duration || 5000 // Default duration at 5000
            );
        },
        deleteImmediately() {
            clearTimeout(this.timeout);
            this.deleteMessage();
        },
        setStateValues() {
            if (this.state === MessageState.ERROR) {
                this.errorIcon = 'exclamation-triangle';
                this.error = true;
            } else if (this.state === MessageState.NOTIFICATION) {
                this.errorIcon = 'envelope';
            }
        },
        errorState() {
            return MessageState.ERROR;
        },
        startAnimation() {
            this.show = false;
            this.$nextTick(() => {
                this.show = true;
            });
        },
    },
    mounted() {
        this.deleteMessageAfterDuration();
        this.setStateValues();
        this.startAnimation();
    },
};
</script>

<style scoped>
.notification-root {
    background-color: white;
    border: 2px solid var(--secondary);
    box-sizing: border-box;

    cursor: pointer;
    z-index: 10000;
}
.notification-root:hover {
    box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
    transform: scale(1.01);
}

.error-root {
    border: 2px solid var(--error);
}

/* STATE COLORS */
.icon-color {
    color: rgba(0, 0, 0, 0.7);
}
.error {
    background-color: var(--error);
    border: none;
}
.error-color {
    color: var(--error);
}
.white-color {
    color: white !important;
}

/* ANIMATIONS */
.slide-enter-active {
    transition: all 0.5s;
}
.slide-leave-active {
    transition: all 0.6s ease;
}
.slide-enter /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(40px);
}
.slide-leave-to {
    transform: translateY(40px);
    opacity: 0;
}

@media only screen and (max-width: 600px) {
    .notification-root {
        width: 100%;
    }
}
</style>
